import AccountCircle from '@mui/icons-material/AccountCircle';
import React from 'react';
import useLocalStorage from "../../../hooks/useLocalStorage";
import { LogOut } from '../../../services/auth.js';
import { Divider } from '@mui/material';
import './index.css';

function UserMenu (open) {
  const [ userLocalStorage, setUserLocalStorage] = useLocalStorage('@login-mastermotion/user', null);
  const [ tokenLocalStorage, setTokenLocalStorage ] = useLocalStorage('@login-mastermotion/token', null);

  async function Exit() {
    await LogOut(tokenLocalStorage);
    setTokenLocalStorage(null);
    setUserLocalStorage(null);
    window.location.replace('https://www.reanimateads.com.br');
  }

  return (
    <div style={{display: open.open ? 'flex' : 'none', width: '200px', padding: '5px 20px', backgroundColor: '#FFFFFF', 
    border: '1px solid #ECECEC', borderRadius: '10px', position: 'absolute', right: '35px', top: '50px', flexDirection: 'column', zIndex: '999'}}>
      <div style={{display: 'flex', alignItems: 'center'}}>
        <AccountCircle/>
        <div style={{display: 'flex', flexDirection: 'column', marginLeft: '8px'}}>
          <span style={{textAlign: 'left', height: '20px'}}><b>{ userLocalStorage ? userLocalStorage.name : "--------------" }</b></span>
          <span style={{textAlign: 'left'}}>{ userLocalStorage ? userLocalStorage.email : "--------------" }</span>
        </div>
      </div>
        <Divider style={{ margin: '10px 0px', width: '100%' }}/>
      <span className="menu-item" onClick={() => window.location.replace("https://www.reanimateads.com.br/me")}
      >Configuração da conta</span>
      <span onClick={() => Exit()} className="menu-item">Sair</span>
    </div>
  )
}

export default UserMenu;
